var isLocalStorageSupport = true;

function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname+"="+cvalue+"; "+expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function selected_country_value() {
    var $countryId = $('#countryId');
    var selected_country = $('#wcsCoutryAndLangId').val();
    if(!selected_country){
        return;
    }
    var langCountry=selected_country.replace('_','-');
    if(langCountry=='en-PL'){
        langCountry='pl-PL';
    } else if(langCountry=='en-PT'){
        langCountry='pt-PT';
    }else if(langCountry=='en-NL'){
        langCountry='nl-NL';
    }else if(langCountry=='en-FI'){
        langCountry='fi-FI';
    }
    var $sel = $('a[lang="'+langCountry+'"]');
    $sel.addClass('wcs-color-active-country');
    $countryId.html($sel.text());
};

function dropscroller_hover_fn() {
    var $document = $(document);
    $('.dropscroller, .scrollable,.dropdown-list').unbind('mouseenter mouseleave').hover(function() {
        $document.bind('mousewheel DOMMouseScroll', function(e) {
            scrollerHandler();
        });
    }, function() {
        $document.unbind('mousewheel DOMMouseScroll');
    });
};

window.remixLC = function(){
    var urlParameter = window.location.search.match(/CL-XTB/i);
    var remixLCUrlParam = urlParameter ? urlParameter[0].toLowerCase() : '';
    var remixPCPUrl = window.location.search.match(/token/i) ? window.location.href : '';

    if(remixLCUrlParam){
        $('#D_Cart_Top_ShopRunner,#footerWrapper .wcs-primary,#footerWrapper .wcs-socialIconsWrapper,#header_virtualmodel').remove();
        $('#selenium-star,#selenium-glass').parent().remove();
        $.cookie("lc-remix", remixPCPUrl, { path: '/' });
    }
    if(getCookie("lc-remix") !== null){
        $('#glass').parent().remove();
        $('#star').parent().remove();
        $('#support').parent().remove();
        $('#selenium-star,#selenium-glass').parent().remove();
        $('.wcs-title_logo a').attr('href','javascript:void(0);');
        $('#D_Cart_Top_ShopRunner,#footerWrapper .wcs-primary,#footerWrapper .wcs-socialIconsWrapper,#D_CheckoutThankYou_NewAccount_Open,#header_virtualmodel').remove();
        $('.wcs-icon-track-order').parent().remove();
    }
};

function sidebarHideFavEmptyDiv() {
    $('#wcs-star-container a.wcs-addtobag.wcs-hide').each(function() {
        $(this).parents('form').addClass('wcs-hide');
    });
}

/*place holder fix for IE8 search*/
function initIe8Search() {
    var searchInput = $("#search-text-box");
    if ($('html').hasClass('ie8') && searchInput.length > 0) {
        window.setTimeout(function() {
            var placeholder = searchInput.attr('placeholder');
            if (searchInput.val() === "" || searchInput.val() == placeholder) {
                searchInput.val(placeholder).css({
                    color: "#ccc"
                });
            }
            searchInput.unbind("focus.search").bind("focus.search", function() {
                if (this.value == placeholder || this.value === '') {
                    this.value = "";
                }
                searchInput.css({
                    color: ""
                });
            }).unbind("blur.search").bind("blur.search", function() {
                if (this.value == placeholder || this.value === '') {
                    this.value = placeholder;
                    searchInput.css({
                        color: "#ccc"
                    });
                }
            });
            $(searchInput).parent().find('[type="submit"]').unbind("click.search").bind("click.search", function(e) {
                if (searchInput.val() == placeholder) {
                    e.preventDefault();
                }
            });
        }, 200);
    }
}

/*for the loading of the social email friend icon*/
window.sharePlus_emailToFriend_bind = function() {
    $('a.wcs-mail-ext10').off('click').on('click', function() {
        var params = {};
        var $this = $(this);
        var $wcsEmailToFriend = $('#wcs_email_to_friend');
        var $catEntryIdForShare = $('#catEntryIdForShare');
        if (!$wcsEmailToFriend.length) {

            var emailSRC = $this.attr('templateView');
            var count = $this.attr('count');
            if (count === undefined) {
                count = "";
            }
            if (emailSRC !== undefined && (emailSRC == "CollectionView" || emailSRC == "FavView") && $catEntryIdForShare.length) {
                params.catEntryId = $catEntryIdForShare.val();
            } else if (emailSRC == "GiftView") {
                params.catEntryId = "";
            } else {
                params.catEntryId = $('#catIdSocial' + count).val();
            }

            var aGiftCardSku = $this.attr('giftSku');
            var shareURL = $this.attr('ShareURL');
            params.shareURL = shareURL;
            params.emailSRC = emailSRC;
            //params.metaTitle = $('#metaTitle' + count).val();
            params.metaTitle = $('#wcs-productdescval').text();
            params.storeId = $('#storeId').val();
            params.catalogId = $('#catalogId').val();
            params.productId = $('#productId' + count).val();
            params.langId = $('#langId').val();


            params.configurationId = $('#configurationIdSocial' + count).val();
            params.sku = $('span#wcs-resolvedskuvalForEmailShare').text();
            params.partNumber = $('#partNumber' + count).val();
            params.altText = $('#altText' + count).val();
            params.title = $('#title' + count).val();
            params.categoryTypeForEmail = $('#categoryTypeForEmail').val();
            if (aGiftCardSku !== undefined) {
                params.giftCardSku = aGiftCardSku;
            }
            var $clearancePrice = $('input#clearancePrice_' + params.catEntryId);
            if (params.emailSRC == "OrderView") {
                var $wcsItemDisplay = $('.wcs-item-display-' + count);
                params.prodCatType = $('#prodCatTypeOrder').val();
                params.metaTitle = $('#wcs-productdescval' + count).html();
                params.price = $('span#wcs-price' + count).html();
                params.sku = $('#wcs-resolvedskuvalSocial_' + count).val();
                params.categoryTypeForEmailOthers = $('#categoryTypeForEmailOthers' + count).val();
                params.roxSet = $wcsItemDisplay.find('#roxSetSocial' + count).val();
                params.roxLensCatentryId = $wcsItemDisplay.find('#roxLensCatentryIdSocial' + count).val();
                params.roxLensPartNumber = $wcsItemDisplay.find('#roxLensPartNumberSocial' + count).val();
                params.catEntryId = $wcsItemDisplay.find('#catIdSocial' + count).val();
                params.configurationId = $wcsItemDisplay.find('#configurationIdSocial' + count).val();
            } else if (params.emailSRC == "CollectionView") {
                params.prodCatType = $('#prodCatTypeCollection').val();
                params.metaTitle = $('#titleSocial_' + params.catEntryId).val();
                if ($('#isClearance_' + params.catEntryId).length > 0 && $('#isClearance_' + params.catEntryId).val() == "true" && $clearancePrice.length && $clearancePrice.val().indexOf(',') != -1) {
                    var splitIndex = $clearancePrice.val().indexOf(',');
                    params.price = $clearancePrice.val().substr(0, splitIndex);
                    params.clearancePrice = $clearancePrice.val().substr(splitIndex + 1, $clearancePrice.val().length);
                } else {
                    params.price = $('span#offerPrice_' + params.catEntryId).html();
                }
                if($('#roxSet_' + params.catEntryId) && $('#roxSet_' + params.catEntryId).length > 0 && $('#roxSet_' + params.catEntryId).val() !== undefined) {
                    params.roxSet = $('#roxSet_' + params.catEntryId).val();
                    params.roxLensCatentryId = $('#roxLensCatentryId_' + params.catEntryId).val();
                    params.roxLensPartNumber = $('#roxLensPartNumber_' + params.catEntryId).val();
               }
                params.sku = $('#partSocialMySelection_' + params.catEntryId).val();
                params.partNumber = $('#partNumberFavSocial_' + params.catEntryId).val();
            } else if (params.emailSRC == "EmailTest") {
                params.prodCatType = $('#prodCatTypePDP').val();
                if ($('#isClearance').length > 0 && $('#isClearance').val() == "true") {
                    params.price = $.trim($('div.wcs-price-clearance>div.wcs-clear-sp-price').html());
                    params.clearancePrice = $.trim($('div.wcs-price-clearance>div.wcs-clear-strike-price>strike').html());
                } else {
                    params.price = $('span#wcs-productprice').html();
                }
            } else if (params.emailSRC == "FavView") {
                if ($('#isClearance_' + params.catEntryId).length > 0 && $('#isClearance_' + params.catEntryId).val() == "true" && $clearancePrice.length && $clearancePrice.val().indexOf(',') != -1) {
                    var splitIndex = $clearancePrice.val().indexOf(',');
                    params.price = $clearancePrice.val().substr(0, splitIndex);
                    params.clearancePrice = $clearancePrice.val().substr(splitIndex + 1, $clearancePrice.val().length);
                } else {
                    params.price = $('span#offerPrice_' + params.catEntryId).html();
                }
                if($('#roxSet_' + params.catEntryId) && $('#roxSet_' + params.catEntryId).length > 0 && $('#roxSet_' + params.catEntryId).val() !== undefined) {
                    params.roxSet = $('#roxSet_' + params.catEntryId).val();
                    params.roxLensCatentryId = $('#roxLensCatentryId_' + params.catEntryId).val();
                    params.roxLensPartNumber = $('#roxLensPartNumber_' + params.catEntryId).val();
               }
                params.metaTitle = $('#metaTitle' + params.catEntryId).val();
                params.sku = $('#sku_' + params.catEntryId).val();
                params.partNumber = $('#partNumberFavSocial_' + params.catEntryId).val();
                params.prodCatType = $('#prodCatTypeFav').val();
            } else if (params.emailSRC == "GiftView") {
                params.metaTitle = $("#wcs-GiftShare").find(".wcs-left").text();
                params.sku = $('span#Gift_share_mfNo').html();
                params.price = $('#Gift_Price').val();
                params.catEntryId = $('#catEntryId').val();
            }
            params.name = $('span#wcs-productdescval').html();
            if(params.price === null) {
                params.price = "";
            }
            var partNum = $('#partNumber').val();
            if (undefined !== $('div.wcs-pdp-product-description').find('span#wcs-productprice>span') &&
                $('div.wcs-pdp-product-description').find('span#wcs-productprice>span').length > 0) {
                params.price = $.trim($('div.wcs-pdp-product-description').find('span#wcs-productprice>span').html());
            }
            $.ajax({
                type: "POST",
                url: "SocialEmailFriend",
                data: params,
                success: function(result) {
                    var $wcsEmailToFriend = $('#wcs_email_to_friend' + params.emailSRC);
                    var $wcsEmailToFriendConfirmation = $('#wcs_email_to_friend_confirmation');
                    var $priceVal = $('#priceVal');
                    if (wcsEmailToFriend.length) {
                        wcsEmailToFriend.remove();
                    }
                    if ($wcsEmailToFriendConfirmation.length) {
                        $wcsEmailToFriendConfirmation.remove();
                    }
                    $(result).insertAfter('footer.wcs-footer');
                    display_Modal_1('wcs_email_to_friend' + params.emailSRC);
                    $wcsEmailToFriend.show();
                    if($priceVal.length){
                        $priceVal.val($priceVal.val().replace('�','&#165;'));
                    }
                    close_lightbox();
                    cancel_link();
                    validateForms($("#wcs_email_to_friend_form"));
                    validateEmail();

                }
            });
        } else {
            display_Modal_1('wcs_email_to_friend' + params.emailSRC);
            $wcsEmailToFriend.show();
        }
    });
};

window.openLinksInNewTab=function(){
    if(window.newTabEnabled){
        $('a[wcs-link-new-tab="true"]').each(function(){
           $(this).attr('target','_blank');
        });
    }
};

//refresh content of Shop Runner
window.shoprunnerUpdateContent = function(){
    var $shoppingCartTitle = $('#shopping_cart_title');
    var $cartMessage = $('.sr_cartMessage');
    var $fullNonSR = $('#fullNonSR');
    var fullNonSRValue = $fullNonSR.val();
    var srMixValue = $('#srMix').val();
    var $srDualEligibilityDiv = $('div[name=sr_dualEligibilityDiv]');
    var $srHeaderDiv = $('div[name=sr_headerDiv]');
    if(getCookie('sr_token') !== null){
        $cartMessage.removeClass('wcs-hide');

        if($fullNonSR.length > 0){
            if($shoppingCartTitle.is(':visible')){
                if(fullNonSRValue == 'false' && srMixValue == 'false' && $shoppingCartTitle.is(':visible')){
                    $srDualEligibilityDiv.addClass('wcs-hide');
                    $srHeaderDiv.removeClass('wcs-hide').addClass('sr_headerDiv');
                }
                if(fullNonSRValue == 'true' || srMixValue == 'true' && $shoppingCartTitle.is(':visible')){
                    $srHeaderDiv.addClass('wcs-hide');
                    $srDualEligibilityDiv.removeClass('wcs-hide').addClass('sr_headerDiv');
                }
            }else{
                $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
                $srHeaderDiv.addClass('wcs-hide');
            }
            if(fullNonSRValue != 'true'){
                var checked = $('input[name=shipping]:checked').attr('id');
                if($('.wcs-shipping-mode').length > 0 && checked == 'wcs-shipping-selector-std'){
                    $cartMessage.prev().addClass('wcs-hide');
                    $cartMessage.removeClass('wcs-hide');
                }else{
                    $cartMessage.prev().removeClass('wcs-hide');
                    $cartMessage.addClass('wcs-hide');
                }
                $('.wcs-shipping-shoprunner').removeClass('wcs-hide');
                $('.wcs-shipping-standard').addClass('wcs-hide');
                if(!$('.wcs-delivery-total-cost .wcs-delivery-subtotal-price .wcs-delivery-cost').hasClass('express')){
                    $('.wcs-delivery-subtotal .wcs-delivery-cost').text('Shoprunner Shipping');
                }
                if(!$('.wcs-product-confirm-div .shipping-cost').hasClass('express')){
                    $('.sr_cartMessage_Confirmation').text('Shoprunner Shipping');
                }
                if($('.sr_headerDiv').length === 0){
                    var $srCartMessage = $('.wcs-cost-innerContainer .sr_cartMessage');
                    $srCartMessage.prev().addClass('wcs-hide');
                    $srCartMessage.removeClass('wcs-hide');
                }

            }else{
                $cartMessage.addClass('wcs-hide');
            }

        }


    }else{
        $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
        $('.sr_cartMessage,.wcs-shipping-shoprunner').addClass('wcs-hide');
    }
    if($shoppingCartTitle.is(':hidden')){
        $srDualEligibilityDiv.removeClass('sr_headerDiv').addClass('wcs-hide');
        $srHeaderDiv.addClass('wcs-hide');
    }
    if($('.wcs-content-bag').is(':visible') || $('.sr_pdp').length > 0){
        if(typeof sr_updateMessages == 'function'){
            sr_updateMessages();
        }
    }
};

jQuery(function($) {
    if(typeof(Storage) !== "undefined") {
        isLocalStorageSupport = true;
    } else {
        isLocalStorageSupport = false;
        // Sorry! No Web Storage support..
    }
    headerFunctions();
});
